import React from 'react';
import { connect } from 'react-redux';
import _ from 'underscore';

import FinishedDiagnostic from './finishedDiagnostic.jsx';
import LandingPage from './landing.jsx';
import PlayDiagnosticQuestion from './sentenceCombining.jsx';

import { CLIP_SOURCE_TYPE, clipSource } from '../../../Shared/libs/speech/clipSource';
import { ReadAloudSource } from '../../../Shared/components/readAloud/readAloudSource';
import FinishedTurkDiagnostic from '../turk/finishedDiagnostic'
import { saveSession, } from '../../utils/saveSession'
import {
  CLICK,
  KEYDOWN,
  KEYPRESS,
  MOUSEDOWN,
  MOUSEMOVE,
  PlayTitleCard,
  ProgressBar,
  SCROLL,
  SmartSpinner,
  TeacherPreviewMenuButton,
  VISIBILITYCHANGE,
  getParameterByName,
  hashToCollection,
  roundValuesToSeconds,
  hasTeacherPreview
} from '../../../Shared/index';
import { clearData, loadData, nextQuestion, resumePreviousDiagnosticSession, setCurrentQuestion, setDiagnosticID, storeResponseInAttempts, updateCurrentQuestion } from '../../actions/diagnostics.js';
import SessionActions from '../../actions/sessions.js';
import { sumTimeTracking } from '../../../Shared/utils/liveViewAPIs';
import { createLiveViewProgress, diagnosticAnsweredPrompts, questionFlowStage } from '../../../Shared/utils/liveViewProgress';
import {
  answeredQuestionCount,
  getProgressPercent,
  questionCount
} from '../../libs/calculateProgress';
import PlayFillInTheBlankQuestion from '../fillInBlank/playFillInTheBlankQuestion';

const TITLE_CARD_TYPE = "TL"
const TURK = 'turk'

// TODO: triage issue with missing title cards. Currently, we have to dipatch data from this.questionsForLesson() to the loadData action in
// three different places to ensure that preview mode always works: componentDidMount, onSpinnerMount & startActivity. Without these three calls,
// sometimes the spinner will hang at 50% or the user will be unable to click title card questions.

export class StudentDiagnostic extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      saved: false,
      sessionID: this.getSessionId(),
      hasOrIsGettingResponses: false,
      startTime: Date.now(),
      isIdle: false,
      timeTracking: {}
    }
  }

  componentDidMount() {
    const { sessionID } = this.state;
    const { dispatch, match, lessons } = this.props;
    const { params } = match;
    const { diagnosticID } = params;

    document.title = `Quill.org | ${lessons.data[diagnosticID].name}`

    dispatch(clearData());
    dispatch(setDiagnosticID({ diagnosticID }))
    if (sessionID) {
      const { timeTracking, } = this.state
      SessionActions.get(sessionID, (data) => {
        if (data) {
          this.setState({ session: data, timeTracking: data.timeTracking || timeTracking });
        }
      });
    }
    const data = this.questionsForLesson()
    const action = loadData(data);
    dispatch(action);

    window.addEventListener(KEYDOWN, this.resetTimers)
    window.addEventListener(MOUSEMOVE, this.resetTimers)
    window.addEventListener(MOUSEDOWN, this.resetTimers)
    window.addEventListener(CLICK, this.resetTimers)
    window.addEventListener(KEYPRESS, this.resetTimers)
    window.addEventListener(SCROLL, this.resetTimers)
    window.addEventListener(VISIBILITYCHANGE, this.setIdle)
  }

  componentDidUpdate(prevProps) {
    const { timeTracking, } = this.state
    const { skippedToQuestionFromIntro, previewMode, playDiagnostic } = this.props;

    if(previewMode && skippedToQuestionFromIntro !== prevProps.skippedToQuestionFromIntro) {
      this.startActivity();
    }
    if (prevProps.playDiagnostic.answeredQuestions.length !== playDiagnostic.answeredQuestions.length) {
      this.saveSessionData({ ...playDiagnostic, timeTracking, });
    }
    this.reportProgressToLiveView()
  }

  componentWillUnmount() {
    if (this.liveViewProgress) { this.liveViewProgress.stop() }
    window.removeEventListener(KEYDOWN, this.resetTimers)
    window.removeEventListener(MOUSEMOVE, this.resetTimers)
    window.removeEventListener(MOUSEDOWN, this.resetTimers)
    window.removeEventListener(CLICK, this.resetTimers)
    window.removeEventListener(KEYPRESS, this.resetTimers)
    window.removeEventListener(SCROLL, this.resetTimers)
    window.removeEventListener(VISIBILITYCHANGE, this.setIdle)
  }

  reportProgressToLiveView = () => {
    const { sessionID, } = this.state
    const { playDiagnostic, previewMode, } = this.props
    if (!sessionID || previewMode || !playDiagnostic.questionSet || this.isTurkSession()) { return }

    if (!this.liveViewProgress) {
      this.liveViewProgress = createLiveViewProgress(sessionID, {
        totalPrompts: questionCount(playDiagnostic),
        getTimeSpentMs: () => {
          const { timeTracking, } = this.state
          return sumTimeTracking(timeTracking)
        },
        getStage: () => {
          const { playDiagnostic, } = this.props
          return questionFlowStage(this.determineActiveStepForTimeTracking(playDiagnostic), playDiagnostic.answeredQuestions)
        },
        getIdle: () => {
          const { isIdle, } = this.state
          return isIdle
        },
      })
    }

    this.liveViewProgress.sync(diagnosticAnsweredPrompts(playDiagnostic.answeredQuestions))
  }

  determineActiveStepForTimeTracking(playDiagnostic) {
    const { currentQuestion, answeredQuestions, } = playDiagnostic

    if (!currentQuestion) { return 'landing' }

    const finishedTitleCards = answeredQuestions.filter(q => q.type === TITLE_CARD_TYPE)
    const finishedQuestions = answeredQuestions.filter(q => q.type !== TITLE_CARD_TYPE)

    if (currentQuestion.type === TITLE_CARD_TYPE) { return `title_card_${finishedTitleCards.length + 1}`}
    if (currentQuestion.type !== TITLE_CARD_TYPE) { return `prompt_${finishedQuestions.length + 1}`}
  }

  isTurkSession = () => {
    const { match, } = this.props
    return match.path.includes(TURK)
  }

  handleStateUpdate = (newState) => {
    this.setState(newState)
  }

  saveToLMS = () => {
    const { sessionID, timeTracking, } = this.state
    const { playDiagnostic, match } = this.props
    saveSession(sessionID, timeTracking, playDiagnostic, match, this.isTurkSession(), this.handleStateUpdate)
  }

  resetTimers = (e=null) => {
    const now = Date.now()
    this.setState((prevState, props) => {
      const { startTime, timeTracking, isIdle, inactivityTimer, completedSteps, } = prevState
      const { playDiagnostic, } = props
      const activeStep = this.determineActiveStepForTimeTracking(playDiagnostic)

      if (inactivityTimer) { clearTimeout(inactivityTimer) }

      let elapsedTime = now - startTime
      if (isIdle || !playDiagnostic.questionSet) {
        elapsedTime = 0
      }
      const newTimeTracking = {...timeTracking, [activeStep]: (timeTracking[activeStep] || 0) + elapsedTime}
      const newInactivityTimer = setTimeout(this.setIdle, 30000);  // time is in milliseconds (1000 is 1 second)

      return { timeTracking: newTimeTracking, isIdle: false, inactivityTimer: newInactivityTimer, startTime: now, }
    })

    return Promise.resolve(true);
  }

  setIdle = () => { this.resetTimers().then(() => this.setState({ isIdle: true })) }

  getPreviousSessionData = () => {
    const { session, } = this.state
    return session;
  }

  resumeSession = (data) => {
    const { dispatch, } = this.props
    if (data) {
      dispatch(resumePreviousDiagnosticSession(data));
    }
  }

  getSessionId = () => {
    let sessionID = getParameterByName('student');
    if (sessionID === 'null') {
      sessionID = undefined;
    }
    return sessionID;
  }

  saveSessionData = (lessonData) => {
    const { sessionID, } = this.state
    if (!sessionID) { return }

    SessionActions.update(sessionID, lessonData);
  }

  doesNotHaveAndIsNotGettingResponses = () => {
    const { hasOrIsGettingResponses, } = this.state
    return (!hasOrIsGettingResponses);
  }

  hasQuestionsInQuestionSet = (props) => {
    const pL = props.playDiagnostic;
    return (pL && pL.questionSet && pL.questionSet.length);
  }

  submitResponse = (response) => {
    const { dispatch, } = this.props
    const action = storeResponseInAttempts(response);
    dispatch(action);
  }

  questionsForDiagnostic = () => {
    const { questions, lessons, match, } = this.props
    const questionsCollection = hashToCollection(questions.data);
    const { data, } = lessons
    const { params } = match
    const { lessonID, } = params
    return data[lessonID].questions.map(id => _.find(questionsCollection, { key: id, }));
  }

  startActivity = () => {
    const { dispatch, previewMode, skippedToQuestionFromIntro, questionToPreview, } = this.props

    const data = this.questionsForLesson()
    const action = loadData(data);
    dispatch(action);

    // when user skips to question from the landing page, we set the current question here in this one instance
    if(previewMode && skippedToQuestionFromIntro && questionToPreview) {
      const action = setCurrentQuestion(questionToPreview);
      dispatch(action);
    } else {
      const next = nextQuestion();
      dispatch(next);
    }
  }

  handleSpinnerMount = () => {
    const { dispatch, } = this.props

    const data = this.questionsForLesson();
    const action = loadData(data);
    dispatch(action);
  }

  nextQuestion = () => {
    const { dispatch, playDiagnostic, previewMode } = this.props;
    const { unansweredQuestions } = playDiagnostic;

    this.resetTimers()
    // we set the current question here; otherwise, the attempts will be reset if the next question has already been answered
    if(previewMode) {
      const question = unansweredQuestions[0].data;
      const action = setCurrentQuestion(question);
      dispatch(action);
    } else {
      const next = nextQuestion();
      dispatch(next);
    }
  }

  getLesson = () => {
    const { lessons, match } = this.props
    const { data } = lessons
    const { params } = match
    const { diagnosticID } = params
    return data[diagnosticID];
  }

  questionsForLesson = () => {
    const { lessons, match } = this.props
    const { params } = match
    const { data, } = lessons
    const { diagnosticID, } = params
    const filteredQuestions = data[diagnosticID].questions.filter(ques => {
      return this.props[ques.questionType] ? this.props[ques.questionType].data[ques.key] : null  // eslint-disable-line react/destructuring-assignment
    }
    );
    // this is a quickfix for missing questions -- if we leave this in here
    // long term, we should return an array through a forloop to
    // cut the time from 2N to N
    return filteredQuestions.map((questionItem) => {
      const questionType = questionItem.questionType;
      const key = questionItem.key;
      const question = this.props[questionType].data[key];  // eslint-disable-line react/destructuring-assignment
      question.key = key;
      question.attempts = question.attempts ? question.attempts : []
      let type
      switch (questionType) {
        case 'questions':
          type = 'SC'
          break
        case 'fillInBlank':
          type = 'FB'
          break
        case 'titleCards':
          type = TITLE_CARD_TYPE
          break
      }
      return { type, data: question, };
    });
  }

  getQuestionCount = () => {
    const { match } = this.props
    const { params } = match
    const { diagnosticID } = params
    if (diagnosticID === 'researchDiagnostic') {
      return '15';
    }
    return '22';
  }

  markIdentify = (bool) => {
    const { dispatch, } = this.props
    const action = updateCurrentQuestion({ identified: bool, });
    dispatch(action);
  }

  getQuestionType = (type) => {
    let questionType
    switch (type) {
      case 'questions':
        questionType = 'SC'
        break
      case 'fillInBlanks':
        questionType = 'FB'
        break
      case 'titleCards':
        questionType = TITLE_CARD_TYPE
        break
    }
    return questionType
  }

  landingPageHtml = () => {
    const { lessons, match } = this.props
    const { params } = match
    const { data } = lessons
    const { diagnosticID, } = params;
    return data[diagnosticID].landingPageHtml
  }

  renderProgressBar = () => {
    const { playDiagnostic, } = this.props
    if (!playDiagnostic.currentQuestion) { return }

    const calculatedAnsweredQuestionCount = answeredQuestionCount(playDiagnostic)

    const currentQuestionIsTitleCard = playDiagnostic.currentQuestion.type === TITLE_CARD_TYPE
    const currentQuestionIsNotFirstQuestion = calculatedAnsweredQuestionCount !== 0

    const displayedAnsweredQuestionCount = currentQuestionIsTitleCard && currentQuestionIsNotFirstQuestion ? calculatedAnsweredQuestionCount + 1 : calculatedAnsweredQuestionCount

    const progressPercent = getProgressPercent(playDiagnostic);
    const totalQuestionCount = questionCount(playDiagnostic);

    return (
      <ProgressBar
        answeredQuestionCount={displayedAnsweredQuestionCount > totalQuestionCount ? totalQuestionCount : displayedAnsweredQuestionCount}
        label='questions'
        percent={progressPercent}
        questionCount={totalQuestionCount}
      />
    )
  }

  render() {
    const { playDiagnostic, dispatch, previewMode, isOnMobile, handleTogglePreview, match, } = this.props
    const { error, saved, } = this.state
    let component;

    const isLastQuestion = playDiagnostic.unansweredQuestions.length === 0
    const studentSession = getParameterByName('student', window.location.href);

    if (!playDiagnostic.questionSet) {
      return (
        <div>
          <div className="student-container student-container-diagnostic">
            <SmartSpinner key="step2" message='Loading Your Lesson 50%' onMount={this.handleSpinnerMount} />
          </div>
        </div>
      );
    }

    if (playDiagnostic.currentQuestion) {
      const questionType = playDiagnostic.currentQuestion.type || '';
      const question = playDiagnostic.currentQuestion.data;
      const key = playDiagnostic.currentQuestion.data.key;
      if (questionType === 'SC') {
        component = (<PlayDiagnosticQuestion
          dispatch={dispatch}
          isLastQuestion={isLastQuestion}
          key={key}
          marking="diagnostic"
          nextQuestion={this.nextQuestion}
          previewMode={previewMode}
          question={question}
        />);
      } else if (questionType === 'FB') {
        component = (<PlayFillInTheBlankQuestion
          currentKey={key}
          dispatch={dispatch}
          isLastQuestion={isLastQuestion}
          key={key}
          nextQuestion={this.nextQuestion}
          previewMode={previewMode}
          question={question}
        />)
      } else if (questionType === TITLE_CARD_TYPE) {
        component = (
          <PlayTitleCard
            currentKey={key}
            data={question}
            dispatch={dispatch}
            handleContinueClick={this.nextQuestion}
            isLastQuestion={isLastQuestion}
            previewMode={previewMode}
          />
        );
      }
    } else if (playDiagnostic.answeredQuestions.length > 0 && playDiagnostic.unansweredQuestions.length === 0) {
      component = this.isTurkSession() ? (
        <FinishedTurkDiagnostic
          error={error}
          saved={saved}
          saveToLMS={this.saveToLMS}
        />
      ) : (
        <FinishedDiagnostic
          saveToLMS={this.saveToLMS}
        />
      );
    } else {
      component = (<LandingPage
        begin={this.startActivity}
        landingPageHtml={this.landingPageHtml()}
        questionCount={this.getQuestionCount()}
        resumeActivity={this.resumeSession}
        session={this.getPreviousSessionData()}
      />);
    }
    return (
      <div>
        {isOnMobile && (!studentSession || hasTeacherPreview()) && !this.isTurkSession() && <TeacherPreviewMenuButton containerClass="is-on-mobile" handleTogglePreview={handleTogglePreview} />}
        {this.renderProgressBar()}
        <div className="student-container student-container-diagnostic">
          <ReadAloudSource source={clipSource(CLIP_SOURCE_TYPE.ACTIVITY, match.params.diagnosticID)}>{component}</ReadAloudSource>
        </div>
      </div>
    );
  }
}

function select(state) {
  return {
    questions: state.questions,
    playDiagnostic: state.playDiagnostic,
    fillInBlank: state.fillInBlank,
    sessions: state.sessions,
    lessons: state.lessons,
    titleCards: state.titleCards
  };
}
export default connect(select)(StudentDiagnostic);
